export default __webpack_public_path__ + "media/cta-section.19041f6f.png";